import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityTemplateOverridesFetchFailedAction = {
	type: 'FACILITY_TEMPLATE_OVERRIDES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityTemplateOverridesFetchFailedAction => ({
	type: 'FACILITY_TEMPLATE_OVERRIDES_FETCH_FAILED',
	payload,
});
